"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _misc = require("HubStyleTokens/misc");

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledWrapper = _styledComponents.default.span.withConfig({
  displayName: "Price__StyledWrapper",
  componentId: "sc-1cvhivr-0"
})(_templateObject(), _misc.WEB_FONT_DEMI_BOLD_WEIGHT);

var Price = function Price(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return _react.default.createElement(StyledWrapper, null, value == null ? children : _react.default.createElement(_FormattedCurrency.default, {
    currencyCode: "USD",
    simplifyCurrency: true,
    value: value
  }));
};

Price.propTypes = {
  children: _propTypes.default.node,
  value: _propTypes.default.number
};
var _default = Price;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/cards/Price.js
// module id = 438
// module chunks = 209 210 211 212